import { PermissionsGate } from 'features/permissions'
import {
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER,
} from 'types'

import { DefinedGateProps } from './AssetOverviewGates'

export const InspectionOverviewAdminGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}

export const InspectionOverviewEditorGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[
        PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN,
        PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR,
      ]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}

export const InspectionOverviewViewerGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[
        PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_ADMIN,
        PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_EDITOR,
        PERMISSION_CANTILEVER_INSPECTION_OVERVIEW_VIEWER,
      ]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}
